import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Icon,
  PageLoader,
  Row,
  Table,
  useToggle,
} from '@met/react-components';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { PageHeader } from '../../components/PageHeader';
import { projectsActions } from '../../store';
import AddProjectModal from './components/AddProjectModal';

const projectColumns = {
  name: {
    label: 'Name',
    toggleable: false,
  },
  translations: {
    label: 'Translations',
    content: project => project.totalTranslationsCount,
  },
  languages: {
    label: 'Languages',
    content: project => project.languages.join(', '),
  },
  completionPercentage: {
    label: 'Completion Percentage',
    content: project =>
      project.totalKeyCount
        ? `${(project.totalTranslationsCount / project.totalKeyCount).toFixed(
            2
          ) * 100}%`
        : 'N/A',
  },
  actions: {
    label: 'Actions',
    content: project => (
      <Link to={`/projects/${project.id}`}>
        <Icon type='pencil' />
      </Link>
    ),
  },
};

const Home = () => {
  const dispatch = useDispatch();
  const projects = useSelector(state => state.projects.projects);
  const projectsLoading = useSelector(
    state => state.projects.getProjects.isLoading
  );
  const [projectModalHidden, toggleProjectModal] = useToggle(true);

  useEffect(() => {
    dispatch(projectsActions.getProjects());
  }, [dispatch]);

  const createProject = useCallback(
    name => {
      return dispatch(projectsActions.createProject(name)).then(() =>
        dispatch(projectsActions.getProjects())
      );
    },
    [dispatch]
  );

  return (
    <div>
      <PageHeader title='Milwaukee Intl Dashboard' />
      <Row>
        <Col xs={12} sm={8}>
          <Card>
            <CardHeader>
              <Icon type='edit' /> Projects
              <div style={{ marginLeft: 'auto' }} id='table-actions' />
            </CardHeader>
            <CardBody>
              {projectsLoading ? (
                <PageLoader />
              ) : (
                <Table
                  striped
                  borderless
                  columns={projectColumns}
                  data={projects}
                  actionsToolbar={{
                    targetElementId: 'table-actions',
                    customActions: [
                      {
                        label: 'Add Project',
                        icon: <Icon type='plus-circle' />,
                        onClick: toggleProjectModal,
                      },
                    ],
                  }}
                />
              )}
            </CardBody>
          </Card>
        </Col>
        <Col xs={12} sm={4}>
          <Card>
            <CardHeader>
              <FontAwesomeIcon icon='info' /> About
            </CardHeader>
            <CardBody>
              <p>
                Milwaukee Intl allows you to manage translations for your
                project. The intended use is for any apps following the i18n
                internationalization convention.
              </p>
              <p>
                This application can manage all translations for your
                application, and output a single unified json file per
                translation. This file can be used within a variety of
                applications, but was specifically geared towards React apps
                using the react-intl library.
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <AddProjectModal
        hidden={projectModalHidden}
        toggle={toggleProjectModal}
        onSaveClick={createProject}
      />
    </div>
  );
};

export default Home;
